export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="hero--section--content">
        <h1 className="skills--section--heading">About Me</h1>
        <p className="hero--section--description">
          I'm a full-stack developer comfortable working with modern
          technologies like JavaScript, TypeScript, React, Next.js, Node.js,
          MongoDB, MySQL, and Git, among others. I enjoy tackling complex
          challenges, stepping outside my comfort-zone, and continuously
          learning in the ever-evolving tech landscape. Whether it's building
          seamless user interfaces or designing scalable server-side systems,
          I'm driven by the opportunity to create impactful projects that make a
          difference.
        </p>
      </div>
    </section>
  );
}
